import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  Slide,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import {
  formatteDateDay,
  formattedDate,
  generateUniqueMatterName,
  pageScrollStyle,
} from "../../../styles/styles";
import DataTable from "../../DataTable";
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid";
import noBillsImg from "../../../assets/no-bills.webp";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllBilles,
  updateStatus,
} from "../../../redux/Apps/Lawyerapp/BillingSlice/BillingSlice";
import { backend_api } from "../../../static/server";
import DriveFileRenameOutlineRoundedIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import { useDialog } from "../../DialogContext";
import BillPreview from "./BillPreview";
import { LoadingButton } from "@mui/lab";
import { deleteCategories } from "../../../redux/Apps/Lawyerapp/ActivitySlice/ActivitySlice";
import { toast } from "react-toastify";
import RecordPaymentFrom from "./RecordPaymentFrom";
import ActionMenuForm from "./ActionMenuForm";
import EditBillForm from "./EditBillForm";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const CustomNoRowsOverlay = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      p: "2rem",
      gap: "1rem",
    }}
  >
    <Box sx={{ height: "9rem" }}>
      <img
        src={noBillsImg}
        alt="Company Logo"
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
        }}
        onError={(e) => {
          e.onerror = null;
          e.target.src = require("../../../assets/no-preview.webp");
        }}
      />
    </Box>
    <Typography variant="body1">Bills not available.</Typography>
  </Box>
);

const CustomToolbar = () => {
  return (
    <GridToolbarContainer className="flex justify-end px-2 py-2">
      <div className="flex gap-2">
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
      </div>
    </GridToolbarContainer>
  );
};

export const generateInvoiceNumber = (id) => {
  return id < 100 ? `INV-${id.toString().padStart(3, "0")}` : `INV-${id}`;
};

const billFilters = [
  { value: "all", label: "All" },
  { value: "draft", label: "Draft" },
  { value: "pending", label: "Pending Approval" },
  { value: "unpaid", label: "Unpaid" },
  { value: "paid", label: "Paid" },
  { value: "archive", label: "Archive" },
];

const Billes = () => {
  const { showDialog } = useDialog();
  const dispatch = useDispatch();
  const [moreMenu, setMoreMenu] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [billId, setBillId] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteLoad, setDeleteLoad] = useState(false);
  const [activeFilter, setActiveFilter] = useState("draft");
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const { token } = useSelector((data) => data.user);
  const { allBilles, loading } = useSelector((state) => state.billing);
  const { pageSize, rowCount, count, nextPage, previousPage } = useSelector(
    (state) => state.billing.pagination
  );

  useEffect(() => {
    fetchBills();
  }, [dispatch, token, activeFilter]);

  const fetchBills = () => {
    let url = `${backend_api}firm-case/bill/`;
    if (activeFilter !== "all") {
      url = `${url}?status=${activeFilter}`;
    }

    dispatch(getAllBilles({ url, token }));
  };

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
  };

  const handleMenuOpen = (event, row, rowId) => {
    setMoreMenu(event.currentTarget);
    setSelectedRow(row);
    setSelectedRowId(rowId);
  };

  const handleDelete = (id) => {
    setBillId(id);
    setOpenDeleteDialog(true);
  };

  const handleDeleteBill = async (id) => {
    setDeleteLoad(true);
    try {
      await dispatch(
        deleteCategories({
          url: `${backend_api}firm-case/bill/${id}/`,
          token: token,
        })
      ).unwrap();
      toast.success("Bill deleted successfully");
      setDeleteLoad(false);
      setOpenDeleteDialog(false);
      fetchBills();
    } catch (error) {
      toast.error("Failed to delete bill");
      setDeleteLoad(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const handlePageChange = (newPage) => {
    setPage(newPage);

    const url =
      activeFilter === "all"
        ? `${backend_api}firm-case/bill/?page=${newPage}`
        : `${backend_api}firm-case/bill/?page=${newPage}&status=${activeFilter}`;
    dispatch(getAllBilles({ url, token }));
  };

  const columns = [
    {
      field: "action",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "0.2rem ",
              width: "100%",
            }}
          >
            <Tooltip title="Edit">
              <IconButton
                color="primary"
                size="small"
                onClick={() => {
                  showDialog(
                    <EditBillForm editBillData={params?.row?.full_data} />,
                    {
                      dialogTitle: "Edit Bill",
                      fullScreen: true,
                      fullWidth: true,
                      width: "100%",
                    }
                  );
                }}
              >
                <DriveFileRenameOutlineRoundedIcon sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Tooltip>

            <Tooltip title="Delete">
              <IconButton
                color="primary"
                size="small"
                aria-label="delete"
                onClick={() => handleDelete(params?.id)}
              >
                <DeleteRoundedIcon sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Tooltip>

            <Tooltip title="More">
              <IconButton
                size="small"
                aria-label="view"
                color="primary"
                onClick={(e) => handleMenuOpen(e, params?.row, params?.row?.id)}
              >
                <MoreVertRoundedIcon sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Tooltip>

            <Menu
              anchorEl={moreMenu}
              open={Boolean(moreMenu) && selectedRowId === params?.row?.id} // Ensure only one menu opens
              onClose={() => {
                setMoreMenu(null);
                setSelectedRowId(null);
              }}
            >
              {params?.row?.status === "draft" && (
                <MenuItem
                  sx={{ fontSize: "0.9rem" }}
                  onClick={() => {
                    setMoreMenu(null);

                    const body = {
                      case: params?.row?.full_data?.case?.id,
                      expenses:
                        params?.row?.full_data?.expenses?.map(
                          (exp) => exp.id
                        ) || [],
                      status: "pending",
                      due_date: params?.row?.full_data?.due_date,
                      firm: params?.row?.full_data?.firm?.id,
                    };

                    showDialog(
                      <ActionMenuForm
                        form_type={"submitAproval"}
                        body={body}
                        BillId={params?.id}
                        fetchBills={fetchBills}
                        setActiveFilter={setActiveFilter}
                      />,
                      {
                        dialogTitle: "Ask for approval",
                      }
                    );
                  }}
                >
                  Submit for approval
                </MenuItem>
              )}
              {params?.row?.status === "unpaid" ? (
                <>
                  <MenuItem
                    sx={{ fontSize: "0.9rem" }}
                    onClick={() => {
                      setMoreMenu(null);
                      showDialog(<RecordPaymentFrom entryData={params} />, {
                        dialogTitle: "Record payment",
                      });
                    }}
                  >
                    Record Payment
                  </MenuItem>
                  <MenuItem
                    sx={{ fontSize: "0.9rem" }}
                    onClick={() => setMoreMenu(null)}
                  >
                    Apply trust funds
                  </MenuItem>
                </>
              ) : (
                <>
                  <MenuItem
                    sx={{ fontSize: "0.9rem" }}
                    onClick={() => {
                      setMoreMenu(null);
                      const body = {
                        case: params?.row?.full_data?.case?.id,
                        expenses:
                          params?.row?.full_data?.expenses?.map(
                            (exp) => exp.id
                          ) || [],
                        status: "unpaid",
                        due_date: params?.row?.full_data?.due_date,
                        firm: params?.row?.full_data?.firm?.id,
                      };
                      dispatch(
                        updateStatus({
                          id: params?.id,
                          data: body,
                          token: token,
                        })
                      );
                      fetchBills();
                      setActiveFilter("unpaid");
                    }}
                  >
                    Approve bill
                  </MenuItem>
                  <MenuItem
                    sx={{ fontSize: "0.9rem" }}
                    onClick={() => setMoreMenu(null)}
                  >
                    Approve & apply trust
                  </MenuItem>
                </>
              )}
              <MenuItem
                sx={{ fontSize: "0.9rem", display: "flex", gap: "0.5rem" }}
                onClick={() => {
                  setMoreMenu(null);
                  if (selectedRow) {
                    showDialog(<BillPreview entryData={selectedRow} />, {
                      dialogTitle: selectedRow.invoice_num,
                      width: "50rem",
                    });
                  }
                }}
              >
                View Bill
              </MenuItem>
              <MenuItem
                sx={{ fontSize: "0.9rem" }}
                disabled
                onClick={() => setMoreMenu(null)}
              >
                Send Bill
              </MenuItem>
              <MenuItem
                sx={{ fontSize: "0.9rem" }}
                onClick={() => {
                  setMoreMenu(null);
                  if (selectedRow) {
                    showDialog(
                      <BillPreview entryData={selectedRow} autoDownload={true} />,
                      {
                        dialogTitle: selectedRow.invoice_num,
                        width: "50rem",
                      }
                    );
                  }
                }}
              >
                Download Bill
              </MenuItem>
            </Menu>
          </Box>
        );
      },
    },
    { field: "invoice_num", headerName: "Invoice Number", width: 150 },
    { field: "last_sent", headerName: "Last sent", width: 150 },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        const statusColors = {
          draft: "info", // Grey
          pending: "warning", // Yellow
          unpaid: "error", // Red
          paid: "success", // Green
        };

        return (
          <Chip
            size="small"
            label={
              params.value === "draft"
                ? "Draft"
                : params.value === "pending"
                ? "Pending Approval"
                : params.value === "unpaid"
                ? "Unpaid"
                : params.value === "paid"
                ? "Paid"
                : "-"
            }
            color={statusColors[params.value] || "default"}
            variant="outlined"
          />
        );
      },
    },
    {
      field: "client",
      headerName: "Client",
      width: 160,
    },
    {
      field: "case",
      headerName: "Matter",
      width: 150,
    },
    { field: "issue_date", headerName: "Issue Date", width: 150 },
    { field: "due_date", headerName: "Due Date", width: 150 },
    { field: "balance", headerName: "Balance", width: 150 },
  ];

  const rows = useMemo(() => {
    if (!Array.isArray(allBilles)) return [];

    const filteredBills = searchTerm
      ? allBilles.filter(
          (item) =>
            (item?.case?.case_related_person?.first_name || "")
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            (item?.case?.case_related_person?.last_name || "")
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            (item?.case?.case_name || "")
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            generateInvoiceNumber(item?.id || 0)
              .toLowerCase()
              .includes(searchTerm.toLowerCase())
        )
      : allBilles;

    return filteredBills?.map((item) => {
      return {
        id: item?.id ?? "-",
        last_sent: item?.last_sent ?? "-",
        invoice_num: item?.id ? generateInvoiceNumber(item?.id) : "-",
        status: item?.status ?? "-",
        // due: item?.due_date ? formatteDateDay(item?.due_date) : "-",
        client:
          item?.case && item?.case?.case_related_person
            ? `${item?.case?.case_related_person?.first_name} ${item?.case?.case_related_person?.last_name}`
            : "-",
        case: item?.case?.id
          ? generateUniqueMatterName(item?.case?.id, item?.case?.case_name)
          : "-",
        issue_date: item?.issue_date ? formatteDateDay(item?.issue_date) : "-",
        due_date: item?.due_date ? formatteDateDay(item?.due_date) : "-",
        balance: item?.total_amount ?? "-",
        full_data: item?.id ? item : null,
      };
    });
  }, [allBilles, searchTerm]);

  return (
    <>
      <div className="w-full">
        <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <Box
            className="bg-white rounded-lg justify-between h-[80vh] p-2 w-full shadow-lg"
            sx={{ ...pageScrollStyle, overflow: "auto" }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "0.8rem",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.8rem",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "0.5rem",
                      p: "0.2rem",
                      borderRadius: "0.5rem",
                      border: "1px solid #e5e5e5",
                    }}
                  >
                    {billFilters?.map((filter) => (
                      <Button
                        size="small"
                        key={filter.value}
                        variant={
                          activeFilter === filter.value ? "contained" : "text"
                        }
                        sx={{ textTransform: "capitalize", fontSize: "0.8rem" }}
                        onClick={() => handleFilterChange(filter.value)}
                      >
                        {filter.label}
                      </Button>
                    ))}
                  </Box>
                </Box>
                <Box sx={{ display: "flex", gap: "1rem" }}>
                  <Box>
                    <TextField
                      size="small"
                      placeholder="Search bills"
                      className="flex-1"
                      label="Search"
                      sx={{ width: "15rem" }}
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  </Box>
                  <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<FilterListRoundedIcon />}
                  >
                    Filter
                  </Button>
                </Box>
              </Box>

              <Box>
                <DataTable
                  columns={columns}
                  rows={rows}
                  CustomToolbar={CustomToolbar}
                  CustomNoRowsOverlay={CustomNoRowsOverlay}
                  loading={loading}
                  page={page}
                  setPage={setPage}
                  pageSize={pageSize}
                  rowCount={rowCount}
                  count={count}
                  onPageChange={handlePageChange} // This should be called when page changes
                  hasNextPage={nextPage !== null}
                  hasPreviousPage={previousPage !== null}
                />
              </Box>
            </Box>
          </Box>
        </Box>
        {/* --------------------- CONFORMATION OF DELETE --------------------- */}
        <Dialog
          open={openDeleteDialog}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setOpenDeleteDialog(false)}
        >
          <DialogTitle>Are you sure you want to delete this bill?</DialogTitle>
          <DialogActions>
            <Button
              size="small"
              variant="outlined"
              color="primary"
              onClick={() => setOpenDeleteDialog(false)}
            >
              Cancel
            </Button>

            <LoadingButton
              loading={deleteLoad}
              size="small"
              variant="contained"
              color="error"
              onClick={() => handleDeleteBill(billId)}
            >
              Delete
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Billes;
